import { useRef } from 'react'
import { useDropzone } from 'react-dropzone'
import { Button } from '@/client/components/Button'
import { Icon } from '@/client/components/Icon'
import { Text } from '@/client/components/Text'
import color from '@/client/components/theme/color'
import * as S from './styles'
import { Props } from './types'

/**
 *   UploadWideCompactFiles (Styled Version)
 */

export const UploadFiles = ({ upload, isError, text }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: upload,
    accept: { 'application/pdf': [] },
    multiple: true
  })
  return (
    <S.DropArea {...getRootProps()} activeDND={isDragActive} isError={isError}>
      <S.ProgressContainer>
        <Icon name='upload-cloud' size='s6' color={color.text['primary-light'] as string} />
        <Text as={'p'} size='sm' color='primary-light' weight='bold'>
          {text}
        </Text>
        <Text as='div' color='weak' dangerouslySetInnerHTML={{ __html: `<p>sdf</p>` }} />
      </S.ProgressContainer>
      <S.HiddenInput
        multiple={true}
        accept='application/pdf'
        onChange={(event) => event.target.files && upload(event.target.files)}
        {...getInputProps()}
      />
      <Button onClick={() => inputRef?.current?.click()}>{text}</Button>
    </S.DropArea>
  )
}
